import { render, staticRenderFns } from "./confirmOptions.vue?vue&type=template&id=2364b599&scoped=true"
import script from "./confirmOptions.vue?vue&type=script&lang=js"
export * from "./confirmOptions.vue?vue&type=script&lang=js"
import style0 from "./confirmOptions.vue?vue&type=style&index=0&id=2364b599&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2364b599",
  null
  
)

export default component.exports